import getConfig from "next/config";
const { publicRuntimeConfig = {} } = getConfig() || {};

export const SUCCESS = "SUCCESS";
export const REQUESTING = "REQUESTING";
export const ERROR = "ERROR";
export const FAILURE = "FAILURE";
export const ACCESS_TOKEN = "accesToken";
export const API_URL_ROOT = "https://frontdoor.cicd-stag.moveaws.com/far-backend-ecs-keyless";
export const IMG_TYPE = {
  JPG: "JPG",
  WEBP: "WEBP",
};
// Predictive search Geo Api and End-Point
export const GEO_PREDICTIVETEXT_API_URL = "https://api.frontdoor.realtor.com/parser/suggest";
export const GEO_PREDICTIVETEXT_API_IP_LOCATION_ENDPOINT = "?client_id=far&input=";

//   Omniture Base url
export const OMNITURE_BASE_URL = "//assets.adobedtm.com/faebb50624175676cb77dee13f41dc903c81f27e/";
export const OMNITURE_END_POINT = "satelliteLib-55d21e8caa3d58b6207a9d1707e7dce9f3f19a44";

// Rating Review API Variable
export const RATING_REVIEW_BASE_URI =
  "https://reviews-service.tphub-qa.moveaws.com/api/external/v1/";
export const RATING_REVIEW_BASE_URI_END_POINT = "feedback";
export const RATING_REVIEW_USER_KEY = publicRuntimeConfig.RATING_REVIEW_USER_KEY;

//  Profile API Variables
export const PROFILE_SEARCH_API_PROSOFT_TOKEN =
  publicRuntimeConfig.PROFILE_SEARCH_API_PROSOFT_TOKEN;
export const PROFILE_SEARCH_API_CLIENT = "FAR2.0";
export const PROFILE_SEARCH_API_VERSION = "v1";
export const PROFILE_SEARCH_API_BASE_URI = "https://eai-profile.tphub-qa.moveaws.com/restricted/";
export const PROFILE_DOT_REALTOR_SEARCH_TOKEN =
  publicRuntimeConfig.PROFILE_DOT_REALTOR_SEARCH_TOKEN;

// Graphql Api qa
export const REVIEW_SERVICE_API_BASE_URI = "https://reviews-service.tphub-qa.moveaws.com";

//  Hestia API for Properties
export const HESTIA_API_BASE_URI = "https://frontdoor.cicd-stag.moveaws.com/graphql-internal";
export const SELECT_TYPE = {
  AGENT: "agent",
  TEAM: "team",
  OFFICE: "company",
};
export const GOOGLE_MAP = {
  REALTOR_MAP_KEY: publicRuntimeConfig.REALTOR_MAP_KEY,
  DOT_REALTOR_MAP_KEY: publicRuntimeConfig.DOT_REALTOR_MAP_KEY,
  SRP: {
    WIDTH: "100%",
    HEIGHT: "82.5vh",
  },
  GESTURE_HANDLING: {
    COORPERATIVE: "cooperative",
  },
  ZOOM: 10,
  MULTI_POLYGON: "MultiPolygon",
};

export const SEO_SCHEMA = {
  SRP_SILO: {
    srp: "SRP",
    agent: "FAR_AGENTS_SRP",
    team: "FAR_TEAMS_SRP",
    office: "FAR_AGENCY_SRP",
    company: "FAR_AGENCY_SRP",
  },
  LDP_SILO: {
    ldp: "LDP",
    agent: "FAR_AGENTS_LDP",
    team: "FAR_TEAMS_LDP",
    office: "FAR_AGENCY_LDP",
    company: "FAR_AGENCY_LDP",
  },
  LP_SILO: {
    FAR_LP: "FAR_LP",
  },
};

const getDropDownOptionsBase = (lang) => {
  return [
    {
      text: lang?.home_content?.dropdown_options?.team,
      value: lang?.home_content?.dropdown_options?.team,
    },
    {
      text: lang?.home_content?.dropdown_options?.company,
      value: lang?.home_content?.dropdown_options?.company,
    },
  ];
};

export const getDropDownOptions = (lang) => {
  return [
    {
      text: lang?.home_content?.dropdown_options?.agent,
      value: lang?.home_content?.dropdown_options?.agent,
    },
    ...getDropDownOptionsBase(lang),
  ];
};

export const getDropDownOptionsPaid = (lang) => {
  return [
    ...getDropDownOptionsBase(lang),
    {
      text: lang?.home_content?.dropdown_options?.agent,
      value: lang?.home_content?.dropdown_options?.agent,
    },
  ];
};
